import React, { useState, useEffect, useRef } from 'react';
import ReactECharts from 'echarts-for-react';
import { useSelector } from 'react-redux';
import ColorPalette from './charts_color';
import axios from 'axios';
import * as echarts from "echarts";
import { BASE_URL } from '../../../commonConfig/ApiConfig';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { FaFilter, FaSlidersH, FaTrashAlt, FaSortAmountDownAlt, FaSortAmountUpAlt, FaChevronUp, FaChevronDown } from 'react-icons/fa';
import { MdInfoOutline } from "react-icons/md";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import BarFilterPopup from './filtercomponents/bar_filter';
import WorkspaceSidePanel from "components/cmn_workspace/workspace_button";
import WorkspaceButton from "components/pages/workspacebtn/workspacebtn";
import { setWorkspaceLoaded } from 'store/workspaceSlice';
import { useBreakpoints } from 'hooks/useBreakpoints';
import SaveCharts from 'components/pages/map/mapConfig/SaveChart';

const BarChart = ({ chart_location_payload }) => {
    const [apiData, setApiData] = useState(null);
    const [showConfigPopup, setShowConfigPopup] = useState(false);
    const [selectedPalette, setSelectedPalette] = useState(['#5470C6', '#91CC75', '#EE6666', '#f7be47', '#62b3d6', '#8c6d31', '#6e4a1f']);

    const [showFilterPopup, setShowFilterPopup] = useState(false);
    const [showBarFilterPopup, setShowBarFilterpoup] = useState(false);
    const [isVertical, setIsVertical] = useState(false);
    const chartRef = useRef(null);
    const [isExportDropdownOpen, setExportDropdownOpen] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();
    const { breakpoints } = useBreakpoints();
    //=========== Mobile View =============
    const isMobile = breakpoints.down('md');
    const { formattedPayload, payload, reduxPayload } = location.state || {};
    const mainpayload = chart_location_payload || payload
    const mainformattedpayload = chart_location_payload || formattedPayload
    const [currentPayload, setCurrentPayload] = useState(mainpayload);
    const [currentFormattedPayload, setCurrentFormattedPayload] = useState(mainformattedpayload);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedListType, setSelectedListType] = useState(null);
    const [activeXSort, setActiveXSort] = useState(null); // 'asc' | 'desc' | null
    const [activeYSort, setActiveYSort] = useState({ indicatorId: null, subIndicatorId: null, direction: null });
    const [allStates, setAllStates] = useState([]);
    const [allDistricts, setAllDistricts] = useState([]);
    const [allULBs, setAllULBs] = useState([]);
    const [chartData, setChartData] = useState(null); // ← bar chart data
    const [locationMetaData, setLocationMetaData] = useState(null); // ← location metadata
    const [selectedItems, setSelectedItems] = useState([]);
    const isBarChartsPage = location.pathname.includes('barChart'); // ←to disable the filter button
    const isLocationPage = location.pathname.includes("/location");
    const selectedMapFeatures = useSelector(state => state.workspace.selectedMapFeatures);
    const [expanded, setExpanded] = useState({});
    const [showallloc, setShowallloc] = useState(false);
    // Workspace toggle state
    const [showWorkspace, setShowWorkspace] = useState(true);
    const dispatch = useDispatch();
    const selectedIndicators = useSelector(state => state.workspace.selectedIndicators);
    const handleVisualize = (selectedIndicators) => {
        navigate('/mapconfig', { state: { selectedIndicators, selectedMapFeatures } });
    };
    const handleSaveSuccess = (workspaceData) => {
        alert(`Workspace "${workspaceData.name}" saved successfully!`);

        // Always load the saved workspace as current
        if (workspaceData.id && workspaceData.name) {
            setTimeout(() => {
                dispatch(setWorkspaceLoaded({
                    id: workspaceData.id,
                    name: workspaceData.name,
                    workspace: workspaceData
                }));
            }, 100);
        }
    };

    useEffect(() => {
        // ✅ Always define handlers, but conditionally check inside
        const handleClickOutside = (event) => {
            // Only process if at least one dropdown is open
            if (!isExportDropdownOpen && !showConfigPopup) return;

            const exportButton = document.querySelector('.btn.btn-sm.btn-primary');
            const exportMenu = document.querySelector('.dropdown-menu.show');
            const chartButton = document.querySelector('.btn.btn-primary:not(.btn-sm)');
            const chartMenu = document.querySelector('.position-absolute.bg-white');

            // Close export dropdown if click outside
            if (
                isExportDropdownOpen &&
                exportMenu &&
                !exportMenu.contains(event.target) &&
                exportButton &&
                !exportButton.contains(event.target)
            ) {
                setExportDropdownOpen(false);
            }

            // Close chart options if click outside
            if (
                showConfigPopup &&
                chartMenu &&
                !chartMenu.contains(event.target) &&
                chartButton &&
                !chartButton.contains(event.target)
            ) {
                setShowConfigPopup(false);
            }
        };

        const handleEscKey = (event) => {
            // Only process if at least one dropdown is open
            if (!isExportDropdownOpen && !showConfigPopup) return;

            if (event.key === 'Escape') {
                setExportDropdownOpen(false);
                setShowConfigPopup(false);
            }
        };

        // ✅ Always attach listeners (lightweight operations)
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleEscKey);

        // ✅ Always cleanup
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleEscKey);
        };
    }, [isExportDropdownOpen, showConfigPopup]);

    //bar fileter
    const toggleExpand = (id) => {
        setExpanded((prev) => ({ ...prev, [id]: !prev[id] }));
    };
    const grouped = selectedMapFeatures.reduce((acc, item) => {
        const parentId = item.properties?.parent_id;
        if (parentId === 1000) {
            acc[item.id] = { ...item, children: [] };
        } else if (acc[parentId]) {
            acc[parentId].children.push(item);
        } else {
            acc[parentId] = { children: [item] };
        }
        return acc;
    }, {});

    const parents = Object.values(grouped).filter((p) => p.name);
    const onAdd = (data) => {
    }
    const geoLevelLabel = (level) => {
        switch (level) {
            case 1: return "National";
            case 2: return "State / UT";
            case 3: return "District";
            case 4: return "ULG";
            default: return "Unknown";
        }
    };
    // add item
    const addListOfItem = (item) => {
        setSelectedItems((prev) => [...prev, item]);
    };
    // const newCodes = selectedItems.map(item => item.leg_code);
    const newCodes = selectedItems.map(item => ({
        code: item.lgd_code,
        geo_level_code: item.geo_level,
    }));

    const newLocations = selectedItems.map(item => ({
        value: item.lgd_code,
        label: item.name,
        geo_level: item.geo_level,
    }));

    const updatedPayload = {
        ...mainpayload,
        lgd_codes: [...(mainpayload?.lgd_codes || []), ...newCodes],
        selected_Location: [...(mainpayload?.selected_Location || []), ...newLocations],
    };

    const apiFilterForpopup = async (lgd_code, geo_level_code) => {
        try {
            const payload = {
                lgd_code,
                geo_level_code,
            };

            // ✅ Axios POST request
            const response = await axios.post(
                `${BASE_URL}locations/location-details`,
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );


            // ✅ Access API response data
            const data = response.data;


            if (data.success) {
                return data.locations;
            } else {
                console.error("❌ API responded with failure:", data);
                return [];
            }
        } catch (error) {
            console.error("⚠️ Error fetching locations:", error);
            return [];
        }
    };

    useEffect(() => {
        const fetchLocationMetadata = async () => {
            if (!currentPayload) return;
            try {
                const res = await axios.post(
                    `${BASE_URL}indicators/check-value-presence`,
                    currentPayload
                );
                const metadata = res.data?.location_metadata;

                if (!metadata) {
                    console.error('No location_metadata in response', res.data);
                    return;
                }

                setLocationMetaData(metadata); // optional for debugging or later use

                // Generic function to process each list (state, district, ULB)
                const processList = (list) =>
                    list.map((item) => ({
                        lgd_code: item.lgd_code,
                        name: item.name,
                        geo_level: item.geo_level,
                        //disabled: item.status === 'NOT EXIST',
                    }));

                // Set the updated lists
                setAllStates(processList(metadata.state || []));
                setAllDistricts(processList(metadata.district || []));
                setAllULBs(processList(metadata.ulb || []));

            } catch (error) {
                console.error('Error fetching location metadata', error);
            }
        };

        fetchLocationMetadata();
    }, [currentPayload]);
    useEffect(() => {
        if (formattedPayload?.barChartType === "bar") {
            setIsVertical(false)
        }
        else {
            setIsVertical(true)
        }
    })
    const determineDefaultListType = () => {
        if (allStates.length > 0) return "state";
        if (allDistricts.length > 0) return "district";
        if (allULBs.length > 0) return "ulb";
        if ((apiData?.location_info || []).length > 0) return "selected";
        return null;
    };

    useEffect(() => {
        if (!selectedListType) {
            const defaultType = determineDefaultListType();
            if (defaultType) setSelectedListType(defaultType);
        }
    }, [
        selectedListType,
        allStates.length,
        allDistricts.length,
        allULBs.length,
        apiData?.location_info?.length
    ]);


    useEffect(() => {
        const fetchData = async () => {
            if (!currentPayload) return;
            try {
                const res = await axios.post(`${BASE_URL}indicators/bar-chart`, currentPayload);
                //             //if (res.data) {
                //             // setApiData(res.data); 
                //             if (res.data && res.data.indicator_values) {
                //                 const enrichedIndicators = res.data.indicator_values.map((ind) => {
                //                     const match = currentPayload.indicators.find(p => p.i_code === ind.indicator_code);
                //                     return {
                //                         ...ind,
                //                         chart_type: match?.chartType || 'bar'
                //                     };
                //                 });

                //                 setApiData({
                //                     ...res.data,
                //                     indicator_values: enrichedIndicators
                //                 });
                //                 const { indicator_values, location_info } = res.data;

                // // collect all valid location keys from indicator values
                // const validKeys = new Set();
                // indicator_values.forEach(ind => {
                //     Object.keys(ind.values || {}).forEach(k => {
                //         // key format is like "29-2"
                //         validKeys.add(k);
                //     });
                // });

                // // keep only locations that have at least one indicator value
                // const filteredLocations = (location_info || []).filter(loc => {
                //     const key = `${loc.value}-${loc.geo_level}`;
                //     return validKeys.has(key);
                // });

                // setApiData({
                //     ...res.data,
                //     location_info: filteredLocations,
                // });
                if (res.data && res.data.indicator_values) {
                    // Step 1: Enrich indicator_values with chart_type info
                    const enrichedIndicators = res.data.indicator_values.map((ind) => {
                        // Find the matching indicator by both i_code and si_code
                        const match = currentPayload.indicators.find(p =>
                            p.i_code === ind.indicator_code && p.si_code === ind.sub_indicator_code
                        );

                        return {
                            ...ind,
                            chart_type: match?.chartType || 'bar' // default to 'bar' if no match
                        };
                    });
                    // Step 2: Collect all valid location keys from indicator values
                    const validKeys = new Set();
                    enrichedIndicators.forEach(ind => {
                        Object.keys(ind.values || {}).forEach(k => {
                            // key format example: "29-2"
                            validKeys.add(k);
                        });
                    });

                    // Step 3: Filter locations that have at least one indicator value
                    const filteredLocations = (res.data.location_info || []).filter(loc => {
                        const key = `${loc.value}-${loc.geo_level}`;
                        return validKeys.has(key);
                    });
                    const finalLocations = showallloc
                        ? (res.data.location_info || [])
                        : filteredLocations;

                    // Step 4: Set the final combined apiData
                    setApiData({
                        ...res.data,
                        location_info: finalLocations,
                        indicator_values: enrichedIndicators
                    });

                    setLoading(false);
                } else {
                    console.error('API responded but success false or no data', res.data);
                    setLoading(false);
                    setError('API responded but success false or no data');
                }
            } catch (error) {
                console.error('Error fetching data', error);
                setLoading(false);
                setError('Error fetching data');
            }
        };
        fetchData();
    }, [currentPayload]);
    if (loading) return <div>Loading...</div>;
    if (error) return <div>{error}</div>;
    if (!apiData?.indicator_values || apiData.indicator_values.length === 0)
        return (
            <>
                <div className="container-fluid mt-4">
                    <div className="alert alert-info p-4">
                        <h4 className="alert-heading">No data available</h4>
                        <hr />
                        <p className="mb-2"><strong>Possible Reasons:</strong></p>
                        <ul className="mb-0">
                            <li className="mb-2">Selected Locations do not match the Geo levels of the selected indicators</li>
                            <li className="mb-2">
                                Selected indicator values do not exist for the selected locations. Verify this by visiting the locations pages and click on Show Indicator button. The location pages list all indicators having data available for the selected location or its sub levels.
                                <p className="mt-2 ms-3"><em>Ex: In Karnataka page, the show indicators will list the indicators having data for Karnataka, its districts and its ULBs.</em></p>
                            </li>
                        </ul>
                        <div className="text-end">
                            <button className="btn btn-primary" onClick={() => navigate('/mapconfig', { state: currentFormattedPayload })}>
                                <FaSlidersH className="me-1" /> Go Back to Chart Configuration
                            </button>
                        </div>
                    </div>
                </div>
            </>
        );

    const visibleIndicatorsFiltered = apiData?.indicator_values || [];

    const visibleUnits = new Set(
        visibleIndicatorsFiltered.map((ind) => (ind.unit).toLowerCase())
    );
    const groupIndicatorsByScale = (indicators, sortedLgdCodes, maxRatio = 5) => {
        const groups = [];

        indicators.forEach((ind) => {
            const values = sortedLgdCodes.map(({ lgd_code, lgd_geo_level }) => {
                const key = `${lgd_code}-${lgd_geo_level}`;
                const val = ind.values[key];
                return val && val.length ? parseFloat(val[0]) : null;
            }).filter(v => v !== null && !isNaN(v));

            const min = Math.min(...values);
            //const max = Math.max(...values);
            let i_max = Math.max(...values);

            // Convert max to integer if it's greater than 1000

            let max = Math.round(i_max);

            const range = max - min;

            // Try to find a group it can fit into
            let placed = false;
            // for (const group of groups) {
            //     const ratio = max / (group.max || 1);
            //     const invRatio = (group.max || 1) / max;
            //     if (ratio <= maxRatio && invRatio <= maxRatio) {
            //         group.indicators.push(ind);
            //         group.max = Math.max(group.max, max);
            //         group.min = Math.min(group.min, min);
            //         placed = true;
            //         break;
            //     }
            // }
            for (const group of groups) {
                const logDiff = Math.abs(Math.log10(max || 1) - Math.log10(group.max || 1));
                if (logDiff <= 1) { // Same order of magnitude
                    group.indicators.push(ind);
                    group.max = Math.max(group.max, max);
                    group.min = Math.min(group.min, min);
                    placed = true;
                    break;
                }
            }
            if (!placed) {
                groups.push({ indicators: [ind], max, min });
            }
        });

        return groups;
    };


    // -----------------------
    // Sorting logic 
    // -----------------------

    let sortedStatesByName = (apiData?.location_info || []).filter(loc => loc.label && loc.value !== null && loc.value !== undefined).map((loc) => ({
        name: loc.label,
        code: loc.value,
        geo_level: loc.geo_level,
    }));

    if (activeXSort) {
        // Sort by location name
        sortedStatesByName.sort((a, b) =>
            activeXSort === "asc"
                ? a.name.localeCompare(b.name)
                : b.name.localeCompare(a.name)
        );
    } else if (activeYSort.indicatorId || (activeYSort.subIndicatorId && activeYSort.indicatorId)) {
        const indicator = visibleIndicatorsFiltered.find(
            (ind) =>
                ind.indicator_code === activeYSort.indicatorId &&
                ind.sub_indicator_code === activeYSort.subIndicatorId
        );


        if (indicator) {
            sortedStatesByName.sort((a, b) => {
                const keyA = `${a.code}-${a.geo_level}`;
                const keyB = `${b.code}-${b.geo_level}`;
                const valA = indicator.values[keyA]?.length ? parseFloat(indicator.values[keyA][0]) : null;
                const valB = indicator.values[keyB]?.length ? parseFloat(indicator.values[keyB][0]) : null;

                if (valA === null && valB === null) return 0;
                if (valA === null) return 1;
                if (valB === null) return -1;

                return activeYSort.direction === "asc" ? valA - valB : valB - valA;
            });
        }
    }


    let sortedLgdCodes = sortedStatesByName.map((s) => ({
        lgd_code: s.code,
        lgd_geo_level: s.geo_level,
    }));
    let states = sortedStatesByName.map((s) => s.name);

    //let states = sortedStatesByName.map((s) => s.name);

    // Toggle X-axis sort
    const toggleXSort = () => {
        setActiveYSort({ indicatorId: null, direction: null }); // reset Y sort

        setActiveXSort((prev) => {
            if (prev === "asc") return "desc";
            return "asc"; // if null or desc, set to asc
        });
    };


    let sortedIndicators = [...visibleIndicatorsFiltered];

    // Toggle X-axis sort
    const toggleIndicatorSort = (i_code, si_code) => {
        setActiveXSort(null); // reset X sort

        setActiveYSort((prev) => {
            if (prev.indicatorId === i_code && prev.subIndicatorId === si_code) {
                return {
                    indicatorId: i_code,
                    subIndicatorId: si_code,
                    direction: prev.direction === "asc" ? "desc" : "asc",
                };
            }
            return { indicatorId: i_code, subIndicatorId: si_code, direction: "asc" };
        });
    };

    // const handleApplyFilters = (selectedItemsFromPopup, oldpayload) => {
    //     if (!selectedItemsFromPopup || selectedItemsFromPopup.length === 0) return;

    //     const newCodes = selectedItemsFromPopup.map(item => ({
    //         code: item.lgd_code,
    //         geo_level_code: item.geo_level
    //     }));

    //     const newLocations = selectedItemsFromPopup.map(item => ({
    //         value: item.lgd_code,
    //         label: item.name,
    //         geo_level: item.geo_level
    //     }));

    //     const updatedPayload = {
    //         ...oldpayload,
    //         lgd_codes: [...(oldpayload.lgd_codes || []), ...newCodes],
    //         selected_Location: [...(oldpayload.selected_Location || []), ...newLocations],
    //     };

    //     setSelectedItems(selectedItemsFromPopup); // ✅ Update selected UI list
    //     setCurrentPayload(updatedPayload);        // ✅ This triggers bar chart API fetch
    //     setCurrentFormattedPayload(updatedPayload); // For navigation or config
    // };

    // -----------------------
    // Y Axis (Dynamic per unit)
    // -----------------------

    const handleApplyFilters = (selectedItemsFromPopup, oldpayload) => {
        if (!selectedItemsFromPopup || selectedItemsFromPopup.length === 0) {
            alert("Please select at least one location");
            return;
        }

        // ✅ Step 1: Get existing items from old payload WITH type preserved
        const existingCodes = (oldpayload.lgd_codes || []).map(item => ({
            code: item.code,
            geo_level_code: item.geo_level_code,
            ...(item.type && { type: item.type }) // Preserve type if it exists
        }));

        const existingLocations = (oldpayload.selected_Location || []).map(item => ({
            value: item.value,
            label: item.label,
            geo_level: item.geo_level
        }));

        // ✅ Step 2: Create sets for comparison (using lgd_code as key)
        const existingCodesSet = new Set(
            existingCodes.map(item => `${item.code}-${item.geo_level_code}`)
        );

        const selectedCodesSet = new Set(
            selectedItemsFromPopup.map(item => `${item.lgd_code}-${item.geo_level}`)
        );

        // ✅ Step 3: Filter out items from old payload that are NOT in selected (keeping type)
        const filteredExistingCodes = existingCodes.filter(item =>
            selectedCodesSet.has(`${item.code}-${item.geo_level_code}`)
        );

        const filteredExistingLocations = existingLocations.filter(item =>
            selectedCodesSet.has(`${item.value}-${item.geo_level}`)
        );

        // ✅ Step 4: Add new items that are NOT in old payload
        const newItemsToAdd = selectedItemsFromPopup.filter(item =>
            !existingCodesSet.has(`${item.lgd_code}-${item.geo_level}`)
        );

        const newCodesToAdd = newItemsToAdd.map(item => ({
            code: item.lgd_code,
            geo_level_code: item.geo_level
            // Note: New items from popup don't have type, so we don't add it
        }));

        const newLocationsToAdd = newItemsToAdd.map(item => ({
            value: item.lgd_code,
            label: item.name,
            geo_level: item.geo_level

        }));

        // ✅ Step 5: Combine filtered existing + new items
        const finalCodes = [...filteredExistingCodes, ...newCodesToAdd];
        const finalLocations = [...filteredExistingLocations, ...newLocationsToAdd];

        // ✅ Step 6: Create updated payload
        const updatedPayload = {
            ...oldpayload,
            lgd_codes: finalCodes,
            selected_Location: finalLocations,
        };

        setSelectedItems(selectedItemsFromPopup); // ✅ Update selected UI list
        setCurrentPayload(updatedPayload);        // ✅ This triggers bar chart API fetch
    };

    let unitsList = [];
    sortedIndicators.forEach(ind => {
        const unit = ind.unit?.toLowerCase();
        if (!unitsList.includes(unit)) {
            unitsList.push(unit);
        }
    });
    const getAxisRange = (values, forceSymmetric = false) => {
        const cleaned = values.filter(v => v !== null && !isNaN(v));
        if (cleaned.length === 0) return [0, 1];

        const min = Math.min(...cleaned);
        //const max = Math.max(...cleaned);
        let i_max = Math.max(...cleaned);

        // Convert max to integer if it's greater than 1000

        let max = Math.round(i_max);

        if (forceSymmetric || min < 0) {
            const absMax = Math.max(Math.abs(min), Math.abs(max));
            return [-absMax, absMax];
        } else {
            return [0, Math.round(max * 1.1) || 1]; // Add 10% headroom
        }
    };
    // First, scan all data at once to see if any indicator has negative values
    const globalHasNegative = sortedIndicators.some(ind => {
        const values = sortedLgdCodes.map(({ lgd_code, lgd_geo_level }) => {
            const key = `${lgd_code}-${lgd_geo_level}`;
            const val = ind.values[key];
            return val && val.length ? parseFloat(val[0]) : null;
        });
        return values.some(v => v !== null && !isNaN(v) && v < 0);
    });

    const indicatorGroups = groupIndicatorsByScale(sortedIndicators, sortedLgdCodes);

    const dataAxis = indicatorGroups.map((group, idx) => {
        const [min, max] = getAxisRange([group.min, group.max], globalHasNegative);
        const seriesColorIndexMap = {};
        let colorIndexCounter = 0;

        indicatorGroups.forEach((group) => {
            group.indicators.forEach((ind) => {
                const uniqueKey = `${ind.indicator_code}__${ind.sub_indicator_name}`;
                if (!(uniqueKey in seriesColorIndexMap)) {
                    seriesColorIndexMap[uniqueKey] = colorIndexCounter++;
                }
            });
        });

        const rich = {};
        const nameParts = [];

        group.indicators.forEach((ind) => {
            const uniqueKey = `${ind.indicator_code}__${ind.sub_indicator_name}`;
            const colorIdx = seriesColorIndexMap[uniqueKey] % selectedPalette.length;
            const styleKey = `color${colorIdx}`;

            // Add rich text style
            rich[styleKey] = {
                color: selectedPalette[colorIdx],
                fontWeight: 'bold',
            };

            const matchingIndicatorPayload = currentPayload?.indicators?.find(p => p.i_code === ind.indicator_code);
            const hasSubIndicator = matchingIndicatorPayload?.si_code && matchingIndicatorPayload.si_code.trim() !== '';

            const formattedName = hasSubIndicator
                ? `(${ind.sub_indicator_name}) ${ind.indicator_name} (${ind.indicator_date}) `
                : `${ind.indicator_name} (${ind.indicator_date})`;

            // Calculate characters per line for y-axis title based on chart height
            const chartHeight = isLocationPage ? window.innerHeight * 0.75 : window.innerHeight; // 75vh or 100vh
            const availableHeight = chartHeight * 0.8; // 80% of chart height for title
            const fontSize = 9; // Current font size for title
            const lineHeight = 10; // Current line height for title
            const maxLines = Math.floor(availableHeight / lineHeight);

            // Calculate characters per line based on available space for title
            // Assuming average character width is about 0.6 * fontSize
            const avgCharWidth = fontSize * 0.6;
            const availableWidth = 200; // Fixed width from nameTextStyle
            const maxCharsPerLine = 70;//Math.max(10, Math.floor(availableWidth / avgCharWidth)); // Reduced minimum to 10 chars per line

            // Debug logging for title calculation (can be removed in production)
            if (idx === 0) { // Only log for first axis to avoid spam
            }

            const words = formattedName.split(' ');
            const lines = [];
            let currentLine = '';

            words.forEach(word => {
                if ((currentLine + word).length <= maxCharsPerLine) {
                    currentLine += (currentLine ? ' ' : '') + word;
                } else {
                    if (currentLine) lines.push(currentLine);
                    currentLine = word;
                }
            });

            if (currentLine) lines.push(currentLine);

            // No truncation - use all available lines
            const multilineName = lines.join('\n');
            nameParts.push(`{${styleKey}|${multilineName}}`);
        });

        const axisName = nameParts.join('\n\n'); // Use double newline to separate indicators

        return {
            type: 'value',
            name: axisName,
            nameTextStyle: isMobile ? {
                rich: rich, // Rich formatting styles
                align: 'center', // Center align multiline text
            } : {
                rich: rich, // Rich formatting styles
                width: 200, // Fixed width to allow more lines
                overflow: 'break', // Ensure text wraps instead of overflowing
                lineHeight: 10, // Further reduced line height for more lines
                fontSize: 9, // Smaller font size to fit more text
                align: 'center', // Center align multiline text
            },
            nameLocation: 'middle',
            nameGap: isVertical ? 90 : 50, // Increased gap to accommodate 80% height multiline titles
            axisLabel: {
                formatter: function (value) {
                    if (value === null || value === undefined || isNaN(value)) return '';


                    if (Number.isInteger(value)) {
                        return value.toString();
                    } else {
                        return value.toFixed(2);
                    }
                }
            },
            axisTick: { show: true },
            axisLine: { show: true },
            splitLine: { show: idx === 0 },
            position: isVertical
                ? (idx === 0 ? "left" : "right")
                : (idx === 0 ? "bottom" : "top"),
            ...(!isMobile && {
                offset: idx > 1 ? (idx - 1) * 120 : 0,
            }),
            min,
            max
        };
    });

    const loc_data = {
        type: 'category',
        data: states,
        axisLabel: {
            rotate: isVertical ? 90 : 0,
            fontSize: 14,
            rich: states.reduce((acc, _, index) => {
                acc[`color${index}`] = {
                    color: selectedPalette[index % selectedPalette.length], fontWeight: 'bold',
                };
                return acc;
            }, {})
        },
        tooltip: { show: true, formatter: (val) => val }
    }

    // // -----------------------
    // // Series
    // // -----------------------

    const series = [];
    indicatorGroups.forEach((group, groupIndex) => {
        group.indicators.forEach((ind, idx) => {

            const data = sortedLgdCodes.map(({ lgd_code, lgd_geo_level }) => {
                const key = `${lgd_code}-${lgd_geo_level}`;
                const vals = ind.values[key];
                return vals && vals.length ? parseFloat(vals[0]) : null;
            });

            const isLine = ind.chart_type === 'line';

            series.push({
                //name: ind.sub_indicator_name
                name: ind.sub_indicator_name !== 'NA' && ind.sub_indicator_name.trim() !== ''
                    ? `(${ind.sub_indicator_name}) ${ind.indicator_name} (${ind.indicator_date}) `
                    : `${ind.indicator_name} (${ind.indicator_date})`,

                type: isLine ? 'line' : 'bar',
                data,
                itemStyle: isLine
                    ? {
                        //color: 'white', // White line color
                    }
                    : {
                        color: selectedPalette[idx % selectedPalette.length],
                    },
                lineStyle: isLine
                    ? {
                        //color: 'white',
                        width: 0,  // make line visible
                    }
                    : undefined,
                ...(isVertical ? { yAxisIndex: groupIndex } : { xAxisIndex: groupIndex }),
                itemStyle: { color: selectedPalette[(series.length) % selectedPalette.length] },
                emphasis: { focus: 'series' },
                label: { show: false },
                symbol: isLine ? 'circle' : undefined, // circle symbol for line chart
                symbolSize: isLine ? 10 : undefined,  // increase circle size
                itemStyle: {
                    color: selectedPalette[(series.length) % selectedPalette.length],
                    ...(isLine && { borderWidth: 2, borderColor: selectedPalette[(series.length) % selectedPalette.length] }) // optional stroke
                },
            });
        });
    });

    // -----------------------
    // Chart Option
    // -----------------------

    const getOption = () => ({
        tooltip: { trigger: 'axis', axisPointer: { type: 'cross' } },
        //toolbox: { feature: { saveAsImage: { show: true }, }, },
        toolbox: {
            show: false,
            feature: {
                saveAsImage: {
                    show: true,
                    type: "png",
                    name: "BarChart",
                    backgroundColor: "#fff",
                    pixelRatio: 2,
                },
            },
        },
        maintainAspectRatio: false,
        ...(!isMobile && {
            grid: {
                bottom: isVertical ? 150 : 250,
                top: isVertical ? 100 : 150,
                left: isVertical ? 250 : 250,    // Increased left margin for 80% height y-axis titles
                right: isVertical ? 250 : 250,   // Increased right margin for 80% height y-axis titles
                containLabel: true
            },
        }),
        ...(isMobile && {
            grid: {
                bottom: isVertical ? 150 : 250,
                top: isVertical ? 100 : 150,
                //left: isVertical ? 250 : 250,    // Increased left margin for 80% height y-axis titles
                //right: isVertical ? 250 : 250,   // Increased right margin for 80% height y-axis titles
                //containLabel: true
            },
        }),

        // ✅ Legend with ellipsis + full tooltip on hover
        legend: {
            type: "plain",
            orient: 'horizontal',
            //textStyle: { overflow: 'truncate', },
            //data: sortedIndicators.map((ind) => ind.indicator_name),
            data: sortedIndicators.map((ind) => {
                const matchingIndicatorPayload = currentPayload?.indicators?.find(p => p.i_code === ind.indicator_code);
                const hasSubIndicator = matchingIndicatorPayload?.si_code && matchingIndicatorPayload.si_code.trim() !== '';
                return hasSubIndicator
                    ? `(${ind.sub_indicator_name}) ${ind.indicator_name} (${ind.indicator_date}) `
                    : `${ind.indicator_name} (${ind.indicator_date})`;
            }),

            ...(!isMobile && {
                formatter: function (name) { return name; },
                tooltip: { show: true, formatter: (params) => params.name },
                textStyle: { width: 500, overflow: 'break', },
                bottom: 30,
            }),
            ...(isMobile && {
                formatter: function (name) { return name; },
                tooltip: { show: true, formatter: (params) => params.name },
                textStyle: { width: 350, overflow: 'truncate', },
                top: 0,
            })
        },

        // ✅ X Axis with ellipsis + full tooltip
        xAxis: isVertical ? loc_data : dataAxis,
        yAxis: isVertical ? dataAxis : loc_data,
        series,

        color: selectedPalette || undefined,
    });
    ////////////////////////////
    /// export feature 
    ////////////////////////////
    // const handleExportCSV = () => {
    //     if (!apiData || !apiData.indicator_values || !apiData.location_info) return;

    //     const indicators = apiData.indicator_values;
    //     const locations = apiData.location_info;

    //     let csv = "data:text/csv;charset=utf-8,";

    //     // Header
    //     const header = ["Location", ...indicators.map((i) => i.indicator_name)];
    //     csv += header.join(",") + "\n";

    //     // Rows
    //     locations.forEach((loc) => {
    //         const row = [loc.label];
    //         indicators.forEach((ind) => {
    //             const key = `${loc.value}-${loc.geo_level}`;
    //             const val = ind.values?.[key]?.[0] || "-";
    //             row.push(val);
    //         });
    //         csv += row.join(",") + "\n";
    //     });

    //     // Download trigger
    //     const encodedUri = encodeURI(csv);
    //     const link = document.createElement("a");
    //     link.href = encodedUri;
    //     const timestamp = new Date().toISOString()
    //         .replace(/T/, '_')      // Replace 'T' with '_'
    //         .replace(/:/g, '-')     // Replace ':' with '-'
    //         .replace(/\..+/, '');   // Remove milliseconds
    //     const filename = `Bar/Column_Chart_${timestamp}.csv`;
    //     link.download = `${filename}`;
    //     document.body.appendChild(link);
    //     link.click();
    //     document.body.removeChild(link);
    // };
    const handleExportCSV = () => {
        if (!apiData || !apiData.indicator_values || !apiData.location_info) return;

        const indicators = apiData.indicator_values;
        const locations = apiData.location_info;

        let csv = "data:text/csv;charset=utf-8,";

        // --- Prepare first header row (Indicator names) ---
        const header1 = ["Location", ...indicators.map(i => i.indicator_name)];

        // --- Prepare second header row (Sub-indicator names or blank) ---
        const header2 = ["", ...indicators.map(i => i.sub_indicator_name || "")];

        csv += header1.join(",") + "\n";
        csv += header2.join(",") + "\n";

        // --- Data rows ---
        locations.forEach((loc) => {
            const row = [loc.label];
            indicators.forEach((ind) => {
                const key = `${loc.value}-${loc.geo_level}`;
                const val = ind.values?.[key]?.[0] || "";
                row.push(val);
            });
            csv += row.join(",") + "\n";
        });

        // --- Download trigger ---
        const encodedUri = encodeURI(csv);
        const link = document.createElement("a");
        link.href = encodedUri;

        const timestamp = new Date().toISOString()
            .replace(/T/, '_')
            .replace(/:/g, '-')
            .replace(/\..+/, '');
        const filename = `Bar_Column_Chart_${timestamp}.csv`;
        link.download = filename;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleExportImage = () => {
        if (!chartRef.current) return;
        const instance = chartRef.current.getEchartsInstance();
        const url = instance.getDataURL({
            type: "png",
            pixelRatio: 2,
            backgroundColor: "#fff",
        });

        const link = document.createElement("a");
        link.href = url;
        const timestamp = new Date().toISOString()
            .replace(/T/, '_')      // Replace 'T' with '_'
            .replace(/:/g, '-')     // Replace ':' with '-'
            .replace(/\..+/, '');   // Remove milliseconds
        link.download = `Bar/Column_Chart_${timestamp}.png`;
        link.click();
    };
    return (
        <><WorkspaceButton
            showWorkspace={showWorkspace}
            setShowWorkspace={setShowWorkspace}
        />
            <WorkspaceSidePanel showWorkspace={showWorkspace}
                setShowWorkspace={setShowWorkspace}
                onVisualize={handleVisualize}
                onSaveSuccess={handleSaveSuccess} />
            <div className="container-fluid" >
                {/* 🆕 Page Title */}{location.pathname === '/barChart' && (
                    <div className="row mb-3 p-2 ">
                        <div className="col-12">
                            <h3 className="fw-bold">Data Analysis</h3>
                            <hr />
                        </div>
                    </div>)}
                <div className="row" style={{ height: '100%' }}>
                    {/* Top Controls */}
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        {/* <div className="d-flex gap-2">
                        <button className="btn btn-sm btn-primary" disabled={isBarChartsPage} onClick={() => setShowFilterPopup(true)}>
                            <FaFilter className="me-1" /> Filters
                        </button> */}
                        <div className="d-flex gap-2">
                            {/* { isLocationPage&&( <button className="btn btn-sm btn-primary" disabled={isBarChartsPage} onClick={() => setShowFilterPopup(true)}>
                            <FaFilter className="me-1" /> Filters
                        </button>)} */}
                            {(isLocationPage || isBarChartsPage) && (
                                <button
                                    className="btn btn-sm btn-primary"
                                    onClick={() =>
                                        isBarChartsPage
                                            ? setShowBarFilterpoup(true)
                                            : setShowFilterPopup(true)
                                    }
                                >
                                    <FaFilter className="me-1" /> Filters
                                </button>
                            )}
                            {/* barfilter popup */}
                            <BarFilterPopup
                                show={showBarFilterPopup}
                                onClose={() => setShowBarFilterpoup(false)}
                                workspace_locations={selectedMapFeatures}
                                mainpayload={currentPayload}
                                selectedItems={selectedItems}
                                setSelectedItems={setSelectedItems}
                                fetchLocations={apiFilterForpopup}
                                onApply={handleApplyFilters}
                            />
                            {showFilterPopup && (
                                <div
                                    className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                                    style={{ background: 'rgba(0,0,0,0.5)', zIndex: 1050 }}
                                >
                                    <div className="bg-white p-4 rounded shadow" style={{ width: '600px', maxHeight: '80vh', overflowY: 'auto', position: 'relative' }}>

                                        {/* Close Button */}
                                        <button
                                            className="btn-close position-absolute top-0 end-0 m-3"
                                            onClick={() => setShowFilterPopup(false)}
                                        />

                                        {/* Title and Tooltip */}
                                        <h5 className="fw-bold mb-3 d-flex align-items-center gap-2">
                                            Filters
                                            <OverlayTrigger
                                                placement="right"
                                                overlay={
                                                    <Tooltip id="filter-tooltip">
                                                        <ol className="mb-0 ps-3">
                                                            <li>Add with “+”, remove in “All Selected” tab.</li>
                                                            <li>“Show All Children” expands deeper levels (geo level &lt; 4).</li>
                                                            <li>Already added items are disabled.</li>
                                                        </ol>
                                                    </Tooltip>
                                                }
                                            >
                                                <span>
                                                    <MdInfoOutline style={{ cursor: "pointer", color: "#000000" }} />
                                                </span>
                                            </OverlayTrigger>
                                        </h5>
                                        <div className="d-flex w-100 justify-content-between align-items-center mb-2">
                                            <div className="mb-3">
                                                <strong>Location:</strong> {apiData?.location_info?.map(loc => loc.label).join(', ')}
                                            </div>

                                            <div>
                                                <button
                                                    className="btn btn-primary"
                                                    onClick={() => {
                                                        setCurrentPayload(updatedPayload);
                                                        setCurrentFormattedPayload(updatedPayload);
                                                        setShowFilterPopup(false);
                                                    }}
                                                >
                                                    Apply
                                                </button>
                                            </div>
                                        </div>

                                        {/* Buttons */}
                                        {(() => {
                                            const firstLoc = apiData?.location_info?.[0];
                                            const geoLevel = Number(firstLoc?.geo_level);

                                            return (

                                                <div className="d-flex gap-2 mb-3 flex-wrap">
                                                    {geoLevel === 1 && (
                                                        <button
                                                            className={`btn btn-sm ${selectedListType === "state" ? "btn-outline-primary" : "btn-primary"}`}
                                                            onClick={() => setSelectedListType("state")}
                                                        >
                                                            All States
                                                        </button>
                                                    )}

                                                    {(geoLevel === 1 || geoLevel === 2) && (
                                                        <button
                                                            className={`btn btn-sm ${selectedListType === "district" ? "btn-outline-primary" : "btn-primary"}`}
                                                            onClick={() => setSelectedListType("district")}
                                                        >
                                                            All Districts
                                                        </button>
                                                    )}

                                                    {(geoLevel === 1 || geoLevel === 2 || geoLevel === 3) && (
                                                        <button
                                                            className={`btn btn-sm ${selectedListType === "ulb" ? "btn-outline-primary" : "btn-primary"}`}
                                                            onClick={() => setSelectedListType("ulb")}
                                                        >
                                                            All ULBs
                                                        </button>
                                                    )}

                                                    {geoLevel >= 1 && geoLevel <= 4 && (
                                                        <button
                                                            className={`btn btn-sm ${selectedListType === "selected" ? "btn-outline-primary" : "btn-primary"}`}
                                                            onClick={() => setSelectedListType("selected")}
                                                        >
                                                            All Selected
                                                        </button>
                                                    )}
                                                </div>
                                            );
                                        })()}
                                        {/* Search */}
                                        <input
                                            type="text"
                                            placeholder="Search"
                                            className="form-control mb-3"
                                        // onChange={(e) => setSearchQuery(e.target.value)}
                                        />

                                        <ul className="list-group">
                                            {(() => {
                                                let listToShow = [];

                                                if (selectedListType === "state") {
                                                    listToShow = allStates;
                                                } else if (selectedListType === "district") {
                                                    listToShow = allDistricts;
                                                } else if (selectedListType === "ulb") {
                                                    listToShow = allULBs;
                                                    // } else if (selectedListType === "selected") {
                                                    //   listToShow =
                                                    //     apiData?.location_info?.map((loc) => ({
                                                    //       name: loc.label,
                                                    //       leg_code: loc.value,
                                                    //       disabled: false,
                                                    //     })) || [];
                                                    // }
                                                } else if (selectedListType === "selected") {
                                                    const existingSelected = apiData?.location_info?.map((loc) => ({
                                                        name: loc.label,
                                                        lgd_code: loc.value,
                                                        geo_level: loc.geo_level,
                                                        disabled: false,
                                                    })) || [];

                                                    // Merge and deduplicate by leg_code
                                                    const combined = [...existingSelected, ...selectedItems];
                                                    const uniqueMap = new Map();
                                                    combined.forEach(item => {
                                                        uniqueMap.set(item.leg_code, item); // avoids duplicates by leg_code
                                                    });
                                                    listToShow = Array.from(uniqueMap.values());
                                                }


                                                return listToShow.map((item, index) => {
                                                    const isSelected = selectedItems.some((sel) => sel.name === item.name);

                                                    const isDisabled = item.disabled;
                                                    const isSelectedOnly = selectedListType === "selected";

                                                    const listItemStyle = {
                                                        backgroundColor: isDisabled ? "#c4c4c4" : "inherit",
                                                        color: isSelected && !isDisabled ? "#2d7be5" : "inherit",
                                                    };

                                                    return (
                                                        <li
                                                            key={index}
                                                            className={`list-group-item d-flex justify-content-between align-items-center`}
                                                            style={listItemStyle}
                                                        >
                                                            <span>
                                                                {index + 1}. {item.name}
                                                            </span>

                                                            {!isDisabled && (
                                                                <>
                                                                    {isSelectedOnly ? (
                                                                        <button
                                                                            //   onClick={() => {
                                                                            //     const updated = selectedItems.filter(
                                                                            //       (sel) => sel.name !== item.name
                                                                            //     );
                                                                            //     setSelectedItems(updated);
                                                                            //   }}
                                                                            onClick={() => {
                                                                                // Remove from selectedItems
                                                                                setSelectedItems(prev =>
                                                                                    prev.filter(sel => sel.lgd_code !== item.lgd_code)
                                                                                );

                                                                                // Optional: also update currentFormattedPayload if you want immediate UI change (without Apply)
                                                                                // setCurrentFormattedPayload(prev => ({
                                                                                //     ...prev,
                                                                                //     selected_Location: prev.selected_Location?.filter(loc => loc.value !== item.lgd_code)
                                                                                // }));
                                                                            }}
                                                                            className="btn btn-sm btn-danger"
                                                                        >
                                                                            <FaTrashAlt />
                                                                        </button>
                                                                    ) : (
                                                                        <button
                                                                            onClick={() => addListOfItem(item)}
                                                                            className="btn btn-sm btn-outline-primary"
                                                                            disabled={isSelected}
                                                                        >
                                                                            +
                                                                        </button>
                                                                    )}
                                                                </>
                                                            )}
                                                        </li>
                                                    );
                                                });
                                            })()}
                                        </ul>


                                        {/* Info Tooltip (optional) */}
                                        <div className="mt-4 small text-muted">
                                            <ol>
                                                <li>Allows selection of Districts and ULGs in selected State</li>
                                                <li>Click on "All Districts", "All ULGs" to view and add them</li>
                                                <li>Locations with unavailable indicator data are disabled</li>
                                                <li>“All Selected” shows added locations with remove option</li>
                                            </ol>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {location.pathname !== '/location' && (<>
                                <button
                                    className="btn btn-outline-secondary"
                                    onClick={() => navigate('/mapconfig', { state: currentFormattedPayload })}
                                >
                                    <FaSlidersH className="me-1" /> Go Back to Chart Configuration
                                </button><OverlayTrigger
                                    placement="right"
                                    overlay={
                                        <Tooltip id="filter-tooltip">
                                            <ol className="mb-0 ps-3">
                                                <li>Click on 'Go to Chart configuration' to add more indicators to the chart from the workspace.</li>
                                                <li>Go to 'Home' menu link to add additional indicators to the workspace.</li>
                                            </ol>
                                        </Tooltip>
                                    }
                                >
                                    <span>
                                        <MdInfoOutline size={20} style={{ cursor: "pointer", color: "#000000" }} />
                                    </span>
                                </OverlayTrigger>
                                <SaveCharts className="" payload={currentPayload} formattedPayload={currentFormattedPayload} path="/barChart" reduxPayload={reduxPayload} /></>
                            )}

                        </div>
                        {!isMobile && (
                            <div className="d-flex gap-3 align-items-center position-relative">
                                <button
                                    className="btn btn-sm btn-primary text-end"
                                    type="button"
                                    onClick={() => setExportDropdownOpen((prev) => !prev)}
                                >
                                    Export {isExportDropdownOpen ? <FaChevronUp /> : <FaChevronDown />}
                                </button>
                                {isExportDropdownOpen && (
                                    <ul
                                        className="dropdown-menu show"
                                        style={{
                                            display: "block",
                                            position: "absolute",
                                            top: "100%",
                                            left: 0,
                                            zIndex: 1000,
                                        }}
                                    >
                                        <li>
                                            <button className="dropdown-item" onClick={handleExportCSV}>
                                                Export as CSV
                                            </button>
                                        </li>
                                        <li>
                                            <button className="dropdown-item" onClick={handleExportImage}>
                                                Export as Image
                                            </button>
                                        </li>
                                    </ul>
                                )}
                                <div>
                                    <button
                                        className="btn btn-sm btn-primary"
                                        onClick={() => setShowConfigPopup(!showConfigPopup)}
                                    >
                                        Chart Options {showConfigPopup ? <FaChevronUp /> : <FaChevronDown />}
                                    </button>

                                    {showConfigPopup && (
                                        <div
                                            className="position-absolute bg-white border rounded shadow p-3"
                                            style={{ top: '100%', right: 0, zIndex: 1000, minWidth: '150px' }}
                                        >
                                            {/* X-axis Sort */}
                                            <div className="mb-2 ">
                                                <h4 className="mb-2 fs-1 p-1">Sort</h4>
                                                <div
                                                    className={`p-2 rounded d-flex align-items-center justify-content-between ${activeXSort ? "bg-light border border-primary" : "border"}`}
                                                    role="button"
                                                    onClick={toggleXSort}
                                                >
                                                    <span>Locations</span>
                                                    {activeXSort ? (
                                                        activeXSort === "asc" ? <FaSortAmountDownAlt style={{ height: '20px', width: '20px' }} /> : <FaSortAmountUpAlt style={{ height: '20px', width: '20px' }} />
                                                    ) : (
                                                        <FaSortAmountDownAlt style={{ opacity: 0.0 }} />
                                                    )}
                                                </div>
                                            </div>
                                            <ul className="list-group mb-3 gap-2 ">
                                                {visibleIndicatorsFiltered.map((ind, index) => {
                                                    const isYActive = activeYSort.indicatorId === ind.indicator_code && activeYSort.subIndicatorId === ind.sub_indicator_code;
                                                    const direction = activeYSort.direction;
                                                    const formatIndicatorName = (ind) => {
                                                        const matchingIndicatorPayload = currentFormattedPayload?.indicators?.find(
                                                            (p) => p.i_code === ind.indicator_code
                                                        );

                                                        const hasSubIndicator = matchingIndicatorPayload?.si_code && matchingIndicatorPayload.si_code.trim() !== '';

                                                        return hasSubIndicator
                                                            ? `(${ind.sub_indicator_name}) ${ind.indicator_name} (${ind.indicator_date}) `
                                                            : `${ind.indicator_name} (${ind.indicator_date})`;
                                                    };
                                                    return (
                                                        <div
                                                            key={ind.indicator_code || index}
                                                            className={`p-2 rounded d-flex align-items-center justify-content-between ${isYActive ? "bg-light border border-primary" : "border"
                                                                }`}
                                                            onClick={() => toggleIndicatorSort(ind.indicator_code, ind.sub_indicator_code)}
                                                        >
                                                            <span className="small fw-bold truncate-with-tooltip " title={formatIndicatorName(ind)} style={{
                                                                maxWidth: '150px',       /* Adjust as needed */
                                                                whiteSpace: 'nowrap',
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                display: 'inline-block',
                                                                verticalAlign: 'middle',
                                                            }}>{formatIndicatorName(ind)}</span>
                                                            <div>
                                                                {isYActive ? (
                                                                    direction === "asc" ? (
                                                                        <FaSortAmountDownAlt style={{ height: '20px', width: '20px' }} />
                                                                    ) : (
                                                                        <FaSortAmountUpAlt style={{ height: '20px', width: '20px' }} />
                                                                    )
                                                                ) : (
                                                                    <FaSortAmountDownAlt style={{ opacity: 0.0 }} />
                                                                )}
                                                            </div>
                                                        </div>
                                                    );
                                                })}

                                            </ul>

                                            <hr className="my-2" />
                                            <ColorPalette onSelectPalette={setSelectedPalette} />
                                        </div>
                                    )}
                                </div>
                            </div>)}
                    </div>

                    {/* Middle - Chart (70%) */}
                    <div className="col-12" style={{ minheight: isLocationPage ? "75vh" : "800px" }}>
                        {/* <div className="col-12" style={{ minheight: isLocationPage ? "75vh" : "100vh" }}> */}
                        <ReactECharts
                            ref={chartRef}
                            className="w-100"
                            style={{ minHeight: isLocationPage ? "75vh" : isMobile ? "70vh" : "800px" }}
                            //style={{ minHeight: isLocationPage ? "75vh" : "100vh" }}
                            option={getOption()}
                        />

                    </div>
                    <div className="text-start">
                        <p style={{ fontSize: '0.85em', color: '#2c7ce5' }}>
                            <i><b>Note:</b></i>
                        </p>
                        <ol style={{ fontSize: '0.85em', color: '#2c7ce5', paddingLeft: '1em' }}>
                            <li>Click on the legend to show / hide indicators in the chart.</li>
                            <li>The number of geographies displayed on the chart may vary with screen size. Decrease the screen size to view more geographies.</li>
                        </ol>
                    </div>


                    {/* Bottom - Indicators & Locations (30%) */}
                    <div className="col-12" style={{ height: '30%' }}>
                        <div className="row h-100">
                            {/* Indicators (70% width) */}
                            <div className="col-md-8 bg-light p-3" style={{ overflowY: 'auto' }}>
                                <h5 className="f-14 fw-bold">Chart Indicators</h5>
                                {(() => {
                                    const selectedICodes = (currentPayload?.indicators || []).map(ind => ind.i_code);
                                    let indicators = currentFormattedPayload?.barindicator_info
                                        ? Object.values(currentFormattedPayload?.barindicator_info).filter(ind =>
                                            selectedICodes.includes(ind.indicator_code?.toString())
                                        )
                                        : [];
                                    // ✅ Normalize data + remove indicators with no valid data
                                    indicators = indicators
                                        .map(ind => ind.indicatordata ? { ...ind, ...ind.indicatordata } : ind)
                                        .filter(ind => ind.indicator_name && ind.indicator_name !== "NA");

                                    return indicators.length === 0 ? (
                                        <p className="text-muted">No indicators selected</p>
                                    ) : (
                                        <ul className="list-group mb-3">
                                            {indicators.map((ind, index) => (
                                                <li key={ind.indicator_code || index} className="list-group-item">
                                                    <div className="d-flex align-items-start">
                                                        <span className="badge bg-secondary me-2">{index + 1}</span>
                                                        <div>
                                                            <div className="fw-bold text-primary" style={{ fontSize: "13px" }}>
                                                                {ind.indicator_name && (
                                                                    <>
                                                                        <span>{ind.indicator_name}</span>
                                                                        {ind.dataset_name && <span> ({ind.dataset_name})</span>}
                                                                    </>
                                                                )}

                                                                {ind.indicator_date && ind.indicator_date !== "NA" && (
                                                                    <>
                                                                        {" | "}
                                                                        <span
                                                                            style={{
                                                                                backgroundColor: "#2c7ce5",
                                                                                color: "#fff",
                                                                                padding: "0 6px",
                                                                                borderRadius: "4px",
                                                                                fontSize: "12px",
                                                                            }}
                                                                        >
                                                                            {ind.indicator_date}
                                                                        </span>
                                                                    </>
                                                                )}

                                                                {ind.agency_name && ind.agency_name !== "NA" && (
                                                                    <>
                                                                        {" | "}
                                                                        <span>{ind.agency_name}</span>
                                                                    </>
                                                                )}

                                                                {/* {Array.isArray(ind.geo_levels) && ind.geo_levels.length > 0 && (
                                                                    <>
                                                                        {" | "}
                                                                        <span>{ind.geo_levels.join(", ")}</span>
                                                                    </>
                                                                )} */}
                                                            </div>
                                                            <div className="text-muted small">
                                                                {/* Available Geo Levels Section */}
                                                                {ind.geo_levels && ind.geo_levels.length > 0 && (
                                                                    <div className="mt-1 mb-1">
                                                                        <span className="me-2" style={{ fontSize: "0.875rem" }}>Available Geo Levels:</span>
                                                                        {ind.geo_levels.map((level, idx) => (
                                                                            <span
                                                                                key={idx}
                                                                                style={{
                                                                                    backgroundColor: "#28a745",
                                                                                    color: "#fff",
                                                                                    borderRadius: "0.25rem",
                                                                                    padding: "0.2rem 0.5rem",
                                                                                    marginRight: "0.3rem",
                                                                                    fontSize: "0.75rem",
                                                                                    display: "inline-block"
                                                                                }}
                                                                            >
                                                                                {level}
                                                                            </span>
                                                                        ))}
                                                                    </div>
                                                                )}
                                                                {[ind.sector_name, ind.sub_sector_name, ind.sub_sub_sector_name]
                                                                    .filter((val) => val && val !== "NA")
                                                                    .join(" | ")}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    );
                                })()}
                            </div>

                            {/* Locations (30% width) */}
                            <div className="col-md-4 bg-light p-3" style={{ overflowY: 'auto' }}>
                                <h5 className="f-14 fw-bold">Locations</h5>
                                {(() => {
                                    const locations = apiData?.location_info || [];
                                    return locations.length === 0 ? (
                                        <p className="text-muted">No locations selected</p>
                                    ) : (
                                        <ul className="list-group mb-3">
                                            {locations.map((loc, idx) => (
                                                <li key={`loc-${idx}`} className="list-group-item">
                                                    {/* <div className="d-flex align-items-start">
                                                    <span className=" fw-bold f-14">{idx + 1}.&nbsp;</span>
                                                    <div className="fw-bold f-14"> {loc.label}</div>
                                                </div> */}
                                                    <div className="d-flex align-items-start">
                                                        <span className="fw-bold f-14">{idx + 1}.&nbsp;</span>
                                                        <div ><span className="fw-bold f-14">{loc.label}&nbsp;</span><span className="small text-secondary f-12">({geoLevelLabel(loc.geo_level_code || loc.geo_level || 4)})</span></div>
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    );
                                })()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BarChart;